import { Box, Container, Typography, IconButton, Stack } from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import { Link } from "react-router-dom";

export const Footer = () => {
  const onHoverStyle = {
    "&:hover": {
      "& svg": {
        color: "secondary.main",
      },
    },
  };

  return (
    <Box
      component="footer"
      sx={{
        py: 8,
        backgroundColor: "background.paper",
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Stack direction="row" spacing={1}>
            <IconButton
              component="a"
              href="https://github.com/cperault"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
              title="GitHub"
              sx={onHoverStyle}
            >
              <GitHubIcon />
            </IconButton>
            <IconButton
              component="a"
              href="https://linkedin.com/in/cperault"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              title="LinkedIn"
              sx={onHoverStyle}
            >
              <LinkedInIcon />
            </IconButton>
            <IconButton
              component="a"
              href="https://x.com/cricri_dev"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X"
              title="X"
              sx={onHoverStyle}
            >
              <XIcon />
            </IconButton>
          </Stack>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ display: { xs: "none", sm: "block" } }}
          >
            Cursor made with ❤️ by{" "}
            <Typography
              component={Link}
              to="https://ko-fi.com/jamkats"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "primary.main",
                textDecoration: "none",
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  width: "0%",
                  height: "2px",
                  bottom: -4,
                  left: 0,
                  backgroundColor: "secondary.main",
                  transition: "width 0.3s ease-in-out",
                },
                "&:hover::after": {
                  width: "100%",
                },
              }}
            >
              JamKats
            </Typography>
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};
